// Environment variables utility
export const ENV = {
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:8005',
  APP_NAME: import.meta.env.VITE_APP_NAME || 'KRP System',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  ENV: import.meta.env.VITE_ENV || 'development',
  MODE: import.meta.env.MODE,
  DEV: import.meta.env.DEV,
  PROD: import.meta.env.PROD
};

// Debug function to check environment variables
export const debugEnv = () => {
  console.log('🔧 Environment Variables:', ENV);
  console.log('🌐 API Base URL:', ENV.API_URL);
  console.log('🏷️ App Name:', ENV.APP_NAME);
  console.log('📦 Version:', ENV.APP_VERSION);
  console.log('🔍 Mode:', ENV.MODE);
  console.log('🛠️ Is Dev:', ENV.DEV);
  console.log('🚀 Is Prod:', ENV.PROD);
};

export default ENV;